<template>
  <div class="qrcode-container">
    <canvas ref="qrcodeCanvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCode',
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 200
    },
    color: {
      type: Object,
      default: () => ({
        dark: '#000000',
        light: '#ffffff'
      })
    }
  },
  mounted() {
    this.generateQRCode()
  },
  watch: {
    text() {
      this.generateQRCode()
    }
  },
  methods: {
    async generateQRCode() {
      try {
        await QRCode.toCanvas(this.$refs.qrcodeCanvas, this.text, {
          width: this.size,
          color: this.color
        })
      } catch (error) {
        console.error('生成二维码失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.qrcode-container {
  display: inline-block;
}
</style>